const FinBankCreditScoreDashboardI18n = {
  tabs: {
    scoreResult: 'Resultado Score',
    scoreInfo: 'Información General',
  },
  loading: {
    fetchingScore: 'Cargando datos del score...',
  },
  fetchError: 'No fue posible cargar los datos del score. Intente nuevamente en unos instantes.',
  error: {
    title: 'Error',
    missingDocument: 'La propiedad "document" es obligatoria para consultar el score.',
    missingAuthCredentials: 'Informe "tokenProvider" o "integratorToken" para autenticar el componente.',
  },
  refreshDialog: {
    cancel: 'Cancelar',
    confirm: 'Actualizar información',
    withinLimit: {
      title: '¡Importante!',
      message: 'La actualización de esta información generará una nueva consulta con el socio de crédito, que contará en las transacciones de su plan.<br/><br/>¿Desea continuar?',
    },
    limitReached: {
      title: 'Atención',
      message: 'El paquete de consultas contratadas ya se agotó; si continúa, se generará un cargo por consulta excedente.<br/><br/>¿Desea continuar?',
    },
  },
};

export default FinBankCreditScoreDashboardI18n;
